import { graphql } from "@/lib/gql/__generated__";

export const RoomStockUpdate_StockManagementPage = graphql(`
	mutation RoomStockUpdate_StockManagementPage($input: RoomStockInput!) {
		roomStockUpdate(input: $input) {
			userErrors
			roomStock {
				id
				hotelID
				headers {
					date
					weekday
				}
				items {
					roomID
					name
					isInSale
					stocks {
						date
						isAvailable
						remainNum
						isSetPrice
						soldNum
					}
				}
			}
		}
	}
`);
